import React, { useCallback } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import DropTrailerIcon from 'transfix-icons/build/DropTrailerIcon'
import { SingleSelect, ISingleSelectProps } from 'transfix-ui/components/SingleSelect'

const options: ISelectOption<string>[] = [
  { value: 'live-live', label: 'Live-Live' },
  { value: 'live-drop', label: 'Live-Drop' },
  { value: 'drop-live', label: 'Drop-Live' },
  { value: 'drop-drop', label: 'Drop-Drop' },
]

type TOmittedProp =
  | 'id'
  | 'dataTest'
  | 'icon'
  | 'label'
  | 'options'
  | 'onSelect'
  | 'selected'
  | 'emptyStateLabel'

export interface IFilterLoadingMethodProps extends Omit<ISingleSelectProps, TOmittedProp> {
  /**
   * @example 'live-live'
   */
  value: string | undefined
  onChange: (value: string | undefined) => void
}

export const FilterLoadingMethod = ({ onChange, value, ...props }: IFilterLoadingMethodProps) => {
  const selectHandler: ISingleSelectProps['onSelect'] = useCallback(
    (option: ISelectOption<string> | undefined) => {
      const { value: newValue } = option || {}
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <SingleSelect
      id='loads-loading-method-filter'
      dataTest='loads-loading-method-filter'
      label='Loading Method'
      emptyStateLabel='No loading method available'
      icon={<DropTrailerIcon size='large' />}
      selected={value}
      options={options}
      onSelect={selectHandler}
      {...props}
    />
  )
}
